import { BeButton, BeRow } from "@beos-css/react/index.ts";

export function ButtonDemo() {
	return (
		<section id="demo-button">
			<h2>Button (BButton)</h2>
			<p>
				The classic R5 grey 3D button. Press for the inverted (depressed) look; tab to a button for the nav-blue focus underline. "Default"
				draws the grey default-action ring.
			</p>
			<BeRow wrap gap="row">
				<BeButton>Cancel</BeButton>
				<BeButton variant="default">OK</BeButton>
				<BeButton disabled>Unavailable</BeButton>
				<BeButton variant="default" disabled>
					Disabled Default
				</BeButton>
			</BeRow>
		</section>
	);
}
